import { render, staticRenderFns } from "./BoundedContext.vue?vue&type=template&id=ad040662&scoped=true&"
import script from "./BoundedContext.vue?vue&type=script&lang=js&"
export * from "./BoundedContext.vue?vue&type=script&lang=js&"
import style0 from "./BoundedContext.vue?vue&type=style&index=0&id=ad040662&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad040662",
  null
  
)

export default component.exports